import React from 'react';

import app from 'components/app';
import Features from 'components/Features';
import H1 from 'components/typo/Heading/H1';
import H2 from 'components/typo/Heading/H2';
import Page from 'components/Page';
import Section from 'components/Page/Section';
import Wrapper from 'components/Page/Wrapper';
import { centeredHeader } from 'components/Page/Section/styled/jumbotron';
import { useTranslation } from 'lib/i18n';

import { GROUPED_PEOPLE } from './constants';
import peopleImages from './images/people';
import CompanyHistory from './CompanyHistory';

const Company: React.FC = () => {
  const { t } = useTranslation('pages');
  return (
    <Page title={t('company.title')} footer noPadding>
      <>
        <Section sidbColor>
          <Wrapper>
            <H1 css={centeredHeader}>{t('company.title')}</H1>
          </Wrapper>
        </Section>
        <Section beforeWave topWave white>
          <Wrapper>
            <Features keys={['mission', 'vision']} base="company" />
          </Wrapper>
        </Section>
        <Section gray topWave flipTopWave bottomWave>
          <Wrapper>
            <>
              <H2>{t('company.people.title')}</H2>
              {GROUPED_PEOPLE.map(group => (
                <Features
                  key={group.i}
                  keys={group.people}
                  titleKey="name"
                  textKey="job"
                  base="company.people"
                  illustrations={peopleImages}
                  compact
                />
              ))}
            </>
          </Wrapper>
        </Section>
        <Section white>
          <Wrapper>
            <>
              <H2>{t('company.history.title')}</H2>
              <CompanyHistory />
            </>
          </Wrapper>
        </Section>
      </>
    </Page>
  );
};

export default app(Company);
